// extracted by mini-css-extract-plugin
module.exports = {"LeasingTable":"LeasingTable__LeasingTable__3XqU6","photo":"LeasingTable__photo__2cSaI"};